import { TimelineLite, TweenMax } from 'gsap';
import store from 'store';
import toggleScroll from '@/scripts/utils/toggle-body-scroll';
import createEvent from '@/scripts/utils/create-event';
import { ROOT_ELEMENT } from '@/scripts/constants';
import getElementsArray from '@/scripts/utils/get-elements-array';

const STORAGE_KEY = 'hasSeenPreloader';
const STORAGE_VALUE = 'true';

window.addEventListener('load', () => {
  store.set(STORAGE_KEY, STORAGE_VALUE);
});

document.addEventListener('DOMContentLoaded', () => {
  const tl = new TimelineLite({ delay: 1 });

  const coverItems = getElementsArray('[data-animation="cover-text"] *');

  const haveSeenPreloader = store.get(STORAGE_KEY) === STORAGE_VALUE;

  TweenMax.set(coverItems, { autoAlpha: 0, willChange: 'transform, opacity', y: 30 });

  if (!haveSeenPreloader) {
    toggleScroll(true);
    tl.add(TweenMax.to('.preloader .progress', 2, {
      scaleX: 1,
      onComplete: () => {
        toggleScroll(false);
      },
    }));
  }

  tl.add(TweenMax.to('.preloader', 0.6, {
    autoAlpha: 0,
  }));

  function animateCoverItems(itemsArray) {
    return new Promise((resolve) => {
      if (itemsArray.length === 0) {
        resolve();
      }
      tl.add(TweenMax.staggerTo(itemsArray, 0.6, {
        autoAlpha: 1,
        y: 0,
        clearProps: 'all',
      }, 0.2, () => {
        TweenMax.set(itemsArray, { willChange: '' });
        resolve();
      }));
    });
  }

  animateCoverItems(coverItems)
    .then(() => {
      ROOT_ELEMENT.dispatchEvent(createEvent('preloaderEnd'));
    });
});



// WEBPACK FOOTER //
// ./scripts/elements/preloader.js